import { Slider } from '@mui/material';
import { SCALE_CONSTANTS, sliderToScale } from '../../../js/text/scaleUtils';
import { validateRotation } from '../../../js/text/validationUtils';

export const SliderControlsPanel = ({ scale, rotate, onScaleChange, onRotateChange }) => {
  const handleScaleChange = (newValue) => {
    console.log(newValue, scale);
    if (onScaleChange) {
      const actualScale = sliderToScale(newValue);
      onScaleChange(actualScale);
    }
  };

  const handleRotateChange = (newValue) => {
    console.log(newValue, rotate);

    if (onRotateChange) {
      const validatedValue = validateRotation(newValue, 0);
      onRotateChange(validatedValue);
    }
  };

  return (
    <>
      <style>
        {`
          /* Override DARK_THEME_CSS styles to match Control.jsx appearance */
          .slider-controls-panel .MuiSlider-root {
            color: #40ecf0 !important;
            position: relative !important; /* Reset from static to relative */
            overflow: visible !important;
          }
          
          .slider-controls-panel .MuiSlider-track {
            background-color: #40ecf0 !important;
            border: none !important;
            top: 15px !important; /* Reset from 7px to 0 */
            position: absolute !important; /* Reset from relative to absolute */
          }
          
          .slider-controls-panel .MuiSlider-rail {
            background-color: rgba(64, 236, 240, 0.2) !important;
            position: absolute !important; /* Reset from relative to absolute */
          }
          
          .slider-controls-panel .MuiSlider-thumb {
            background-color: #40ecf0 !important;
            border: 1px solid rgba(64, 236, 240, 0.3) !important;
            position: absolute !important; /* Reset from relative to absolute */
            top: 15px !important; /* Reset from 7px to 0 */
          }
          
          .slider-controls-panel .MuiSlider-thumb:hover {
            box-shadow: 0 0 0 4px rgba(64, 236, 240, 0.1) !important;
          }
          
          .slider-controls-panel .MuiSlider-thumb:focus,
          .slider-controls-panel .MuiSlider-thumb.Mui-focusVisible {
            box-shadow: 0 0 0 4px rgba(64, 236, 240, 0.2) !important;
          }
          
          .slider-controls-panel .MuiSlider-thumb:active {
            box-shadow: 0 0 0 6px rgba(64, 236, 240, 0.15) !important;
          }
        `}
      </style>
      <div className="control-top-toolbar slider-controls-panel" style={{ position: 'fixed' }}>
        <div className="control-row">
          <div className="control-label">Scale</div>
          <Slider
            className="control-slider"
            value={scale}
            onChange={(event, value) => handleScaleChange(value)}
            min={SCALE_CONSTANTS.SLIDER_MIN}
            max={SCALE_CONSTANTS.SLIDER_MAX}
            step={SCALE_CONSTANTS.SLIDER_STEP}
          />
        </div>
        <div className="control-row">
          <div className="control-label">Rotate</div>
          <Slider
            className="control-slider"
            value={rotate}
            onChange={(event, value) => handleRotateChange(value)}
            min={0}
            max={360}
            step={1}
          ></Slider>
        </div>
      </div>
    </>
  );
};
